module.exports = __webpack_public_path__ + "static/media/akash.29e2ace3.webp";